import { useContext, createContext, useReducer } from "react";

const createChannelId = (channelId, channelTitle, channelSummary, gender) => ({
  channelId,
  channelTitle,
  channelSummary,
  gender,
});
const SERVICE_CHANNEL_LIST = [
  createChannelId("UCT-_4GqC-yLY1xtTHhwY0hA", "PONY Syndrome", "PONY", "female"),
  createChannelId("UCdtRAcd3L_UpV4tMXCw63NQ", "피지컬갤러리", "Physical", "male"),
  createChannelId("UCgsffS7MfKL6YU3r_U3E-aA", "승우아빠", "SW-Daddy", "male"),
  createChannelId("UCdo8JVwHW1IWfdX9_YMr8DQ", "Dr KKoKKo", "DrKKo", "male"),
];
const initState = {
  serviceChannels: SERVICE_CHANNEL_LIST,
  curChannel: undefined,
  sortedVideos: [],
  selected: [],
  curVideo: undefined,
  speech: undefined,
  speaker: "original",
  voice: null,
  delaySpeakId: undefined,
};

function videoReducer(state, action) {
  switch (action.type) {
    case "deleteServiceChannel":
      const filteredChannels = state.serviceChannels.filter(
        (ch) => ch.channelId !== action.payload.channelId
      );
      console.log("deleteServiceChannel action.payload=", action.payload);
      console.log("deleteServiceChannel filteredChannels=", filteredChannels);
      return { ...state, serviceChannels: filteredChannels };
    case "setChannel":
      return { ...state, curChannel: action.payload, sortedVideos: [], selected: [] };
    case "setVideo":
      return { ...state, curVideo: action.payload };
    case "setSortedVideos":
      return { ...state, sortedVideos: action.payload };
    case "setSelected":
      return { ...state, selected: action.payload };
    case "setSpeech":
      return { ...state, speech: action.payload };
    case "setSpeaker":
      return { ...state, speaker: action.payload };
    case "setVoice":
      return { ...state, voice: action.payload };
    case "setDelaySpeakId":
      return { ...state, delaySpeakId: action.payload };
    default:
      // 'clear'
      return initState;
  }
}

export const VideoContext = createContext();
export function useVideoReducer() {
  return useReducer(videoReducer, initState);
}
export function useVideoContext() {
  return useContext(VideoContext);
}
